import { render, staticRenderFns } from "./comp_BookEditor-Tabs.vue?vue&type=template&id=650cc365&scoped=true&"
import script from "./comp_BookEditor-Tabs.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditor-Tabs.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookEditor-Tabs.vue?vue&type=style&index=0&id=650cc365&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650cc365",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VOverlay,VProgressCircular,VSpacer})
